import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { instanceToPlain, plainToInstance } from 'class-transformer';
import { Report } from '../models/report.model';
import { Language } from '../interfaces/language';
import { ReportCfg } from '../interfaces/report-cfg';
import { ReportRequest } from '../models/reportRequest.model';
import { GeneratePdfBase64Response } from '../models/generate-pdf.model';
import { StudentEngagementListRequest } from '../models/students-engagement-list-request.model';
import { StudentsAttendancesListRequest } from '../models/students-attendances-list-request.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  private apiUrl = `${environment.reportApi}`;
  private pkceUrl = `${environment.sgcApi}`;
  private reportRoute = 'report';

  constructor(
    private httpClient: HttpClient
  ) { }

  getReportsCfg() {
    return this.httpClient.get<ReportCfg>('assets/cfg/reports-cfg.json').pipe(
      map(data => {return data})
    );
  }

  getLanguages() {
    return this.httpClient.get<Language[]>('assets/languages/languages.json').pipe(
      map(data => data)
    );
  }

  getReports(vertical:number, description: string, language: string, status: string) {
    let filters = this.getFilters(language, description, status);
    let endpoint = `${this.apiUrl}${this.reportRoute}/vertical/${vertical}/filter${filters}`;
    return this.httpClient.get<any>(endpoint).pipe(
      map(data => {
        return plainToInstance(Report, data as Report[]);
      })
    );
  }

  getReportDetails(reportId: string, vertical:number): Observable<Report[]> {
    let endpoint = `${this.apiUrl}${this.getDetails(reportId, vertical)}`;
    return this.httpClient.get<Report[]>(endpoint).pipe(
      map(data => {
        return plainToInstance(Report, data as Report[]);
      })
    );
  }

  addReport(report: Report): Observable<string> {
    let endpoint = `${this.apiUrl}${this.reportRoute}`;
    return this.httpClient.post<string>(endpoint, instanceToPlain(report)).pipe(
      map(data => data)
    );
  }

  updateReport(report: ReportRequest): Observable<Report> {
    let endpoint = `${this.apiUrl}${this.reportRoute}`;
    return this.httpClient.put<any>(endpoint, report).pipe(
      map(data => data)
    );
  }

  // No tenemos claro por qué se usaba la activación en un endpoint aparte
  // setActivation(reportActivation: ReportActivation) {
    // let endpoint = `${this.apiUrl}${this.reportRoute}/activation`;
    // return this.httpClient.put<any>(endpoint, reportActivation).pipe(
    //   map(data => data)
    // );
  // }

  generateFamilyReport(reportName: string, familyId: number, exerciseId: number): Observable<GeneratePdfBase64Response> {
    let endpoint = `${this.pkceUrl}${this.reportRoute}/reportName/${reportName}/familyId/${familyId}/exerciseId/${exerciseId}/pdf/stream`;
    return this.httpClient.post<GeneratePdfBase64Response>(endpoint, null);
  }

  generateStudentEngagementListReport(studentEngagementListRequest: StudentEngagementListRequest): Observable<GeneratePdfBase64Response> {
    let endpoint = `${this.pkceUrl}${this.reportRoute}/studentsbyServices`;
    return this.httpClient.post<GeneratePdfBase64Response>(endpoint, JSON.stringify(studentEngagementListRequest));
  }

  generateStudentsAttendancesListReport(studentsAttendancesListRequest: StudentsAttendancesListRequest): Observable<GeneratePdfBase64Response> {
    let endpoint = `${this.pkceUrl}${this.reportRoute}/studentAttendances`;
    return this.httpClient.post<GeneratePdfBase64Response>(endpoint, JSON.stringify(studentsAttendancesListRequest));
  }

  private getDetails = (reportId: string, vertical: number) =>
  `${this.reportRoute}/vertical/${vertical}/filter?filters=reportId=${reportId}`;

  private getFilters(language: string, description: string, status: string) {
    let filters = '';
    if (language) { filters += `language=${language};`; }
    if (description) { filters +=`description=${description};`; }
    if (status !==  '') { filters += `isActive=${status};`; }
    if (filters) { filters = `?filters=${filters}`; }
    return filters;
  }
}
